import axios from 'axios';
import config from './apiConfig';

export const fetchCompanies = () => {

	var headers = {'Authorization': "Bearer " + localStorage.getItem("unfAccessToken")};

	return new Promise(function(resolve, reject) {
		axios({
		    method: 'GET',
		    url: config.baseUrl + '/api/1.1/company' ,
		    headers:headers,
		})
		.then(function (response) {
			console.log("fetchCompanies",response);
		    resolve(response.data);
		})
		.catch(function (error) {
		    console.log(error);
		    reject(error);
		});
	});
}

export default {fetchCompanies}